'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveIconStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = function size(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.tag.removeIcon,
      height = _theme$reactackle$com.height,
      width = _theme$reactackle$com.width,
      imgHeight = _theme$reactackle$com.imgHeight,
      imgWidth = _theme$reactackle$com.imgWidth,
      iconTextSpacing = _theme$reactackle$com.iconTextSpacing;


  return (0, _styledComponents.css)(['margin-left:', ';', ''], (0, _reactackleCore.getValueString)(iconTextSpacing), (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgHeight || height), (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(imgWidth || imgHeight || height)));
};

var style = function style(_ref2) {
  var themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.tag.removeIcon.state;

  var color = path.color,
      backgroundColor = path.backgroundColor;
  var _path$hover = path.hover,
      hoverColor = _path$hover.color,
      hoverBG = _path$hover.backgroundColor;
  var _path$focus = path.focus,
      focusColor = _path$focus.color,
      focusBG = _path$focus.backgroundColor;


  return (0, _styledComponents.css)(['color:', ';background-color:', ';&:hover{color:', ';background-color:', ';}&:focus{color:', ';background-color:', ';}'], color, backgroundColor, hoverColor || color, hoverBG || backgroundColor, focusColor || hoverColor || color, focusBG || hoverBG || backgroundColor);
};

var RemoveIconStyled = exports.RemoveIconStyled = _styledComponents2.default.button.withConfig({
  displayName: 'RemoveIconStyled'
})(['   &,&:hover,&:focus{cursor:pointer;outline:none;box-shadow:none;border:0;padding:0;}', ' ', ' ', ''], size, style, (0, _reactackleCore.transition)('color, background-color'));


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tag/dist/styles/RemoveIconStyled.js
// module id = 831
// module chunks = 0